import Utils from '../../utils/Utils';

import RoutingActions from '../../actions/RoutingActions';
import GuestActions from '../../actions/GuestActions';
import NotificationActions from '../../actions/NotificationActions';

import UserStore from '../../stores/UserStore';
import ConfigStore from '../../stores/ConfigStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as GuestListEndpoints } from '../../constants/GuestListConstants';
import { RegisterLedgerEntryTypes } from '../../constants/RegisterLedgerConstants';

import InputProfile from '../profile/view/InputProfile.react';
import DropdownProfile from '../profile/view/DropdownProfile.react';
import DOBProfile from '../profile/view/DOBProfile.react';
import PageHeader from '../form/layout/PageHeader.react';
import PageRow from '../form/layout/PageRow.react';
import Input from '../form/input/Input.react';
import DD from '../form/dropdown/DD.react';

class GLTransactionsAdjustment extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false,

            amount : 0,
            comment : '',
        };

        this.isValid = this.isValid.bind(this);
        this.adjust = this.adjust.bind(this);
    }

    isValid() {
        return (
            this.state.amount != 0 &&
            this.state.comment.length > 0
        )
    }

    adjust() {
        var self = this;

        if (!this.isValid() || this.state.loading) {
            return;
        }

        this.setState({ loading : true }, () => {

            AjaxPromises.POST(GuestListEndpoints.SET_REGISTER_TRANSACTION, UserStore.getApiData({
                RegisterId : self.props.selectedRegister.id,
                EntryTypeId : RegisterLedgerEntryTypes.AdjustmentPOS,
                Comment : self.state.comment,
                TransactionAmt : self.state.amount
            })).then(res => {
                // if (res.Result) {
                    NotificationActions.success('Register Adjusted');

                    this.setState({comment: '', amount: 0, loading: false});

                    self.props.onReload();
                // } else {
                    // NotificationActions.error('Transaction could not be updated');
                // }
            });
        });
    }

    render() {
        var self = this;
        var page = this.props.page,
            selectedRegister = this.props.selectedRegister;

        return ([

            <PageRow title={
                <Input
                    type='number'
                    value={this.state.amount}
                    onChange={amount => { this.setState({ amount }); }} />
                }>
                <div className='transactions__label'>
                    Amount
                </div>
            </PageRow>,

            <PageRow title={
                <Input
                    value={this.state.comment}
                    onChange={comment => { this.setState({ comment }); }} />
                }>
                <div className='transactions__label'>
                    Comment
                </div>
            </PageRow>,

            <PageRow>
                <div
                    className={'btn-green '+(!this.isValid() ? 'btn-green__disabled' : '')}
                    onClick={this.adjust}>

                    Adjust
                </div>
            </PageRow>,

            <PageRow>
                <div>+$ = Increase Register</div>
                <div>-$ = Reduce Register</div>
            </PageRow>
        ]);
    }
}

export default GLTransactionsAdjustment;


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLTransactionsAdjustment.react.jsx